var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-input-group',_vm._b({},'b-input-group',{ ..._vm.$attrs, ..._vm.$props },false),[(_vm.type != 'hidden')?_c('b-form-input',_vm._g(_vm._b({},'b-form-input',{ ..._vm.$attrs, ..._vm.$props, style: undefined, value: _vm.innateValue },false),{
            ..._vm.$listeners,
            input: ($event) => (_vm.innateValue = $event),
        })):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }